/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'ssmsDate' })
export class SsmsDatePipe extends DatePipe implements PipeTransform {
  override transform(value: any, format?: any): any {
    if (value === undefined || value === null || value === '' || value === 'null' || value === 'undefined') {
      return '';
    }

    try {
      const dateFormat = format || 'dd/MM/yyyy';
      return super.transform(value, dateFormat) || '';
    } catch {
      return '';
    }
  }
}
